module.exports = __webpack_public_path__ + "img/hr-oil-refinery-fire.6de15ec8.png";